
export const get = async (url, headers = {}) => {
  let resp = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    credentials: 'include',
  });

  return handleResponse(resp);
}

export const post = async (url, params, headers = {}) => {
  let resp = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    credentials: 'include',
    body: JSON.stringify(params)
  });

  return handleResponse(resp);
}

export const put = async (url, params, headers = {}) => {
  let resp = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    credentials: 'include',
    body: JSON.stringify(params)
  });

  return handleResponse(resp);
}

export const upload = async (url, file) => {
  const headers = new Headers({
    'Content-Type': file.type
  });

  let resp = await fetch(url, {
    method: 'PUT',
    headers: headers,
    body: file
  });

  return handleResponse(resp);
}

export const patch = async (url, params) => {
  let resp = await fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(params)
  });

  return handleResponse(resp);
}

export const destroy = async url => {
  let resp = await fetch(url, {
    method: 'DELETE',
    credentials: 'include'
  });

  return handleResponse(resp);
}

const handleResponse = async resp => {
  switch (resp.status) {
    case 200:
      if (resp.headers.get('content-type') === 'application/json') {
        return resp.json()
      } else {
        return Promise.resolve(resp);
      }
    case 422:
      let err = await resp.json();
      return Promise.reject(err);
    default:
      return Promise.reject({ error: `Error: HTTP ${resp.status}` });
  }
}
